<template>
  <div>
    <div class="flex items-end justify-between">
      <div class="flex items-end custom-tab">
        <button
          @click="filters = { ...filters, favoritesOnly: false }; applySorting()"
          class="unClick-mode mx-2 px-8"
          :class="{ 'click-mode': !filters.favoritesOnly }"
        >
          All
        </button>
        <button
          @click="filters = { ...filters, favoritesOnly: true }; applySorting()"
          class="unClick-mode mx-2 px-8"
          :class="{ 'click-mode': filters.favoritesOnly }"
        >
          Favorites
        </button>
      </div>
      <div class="flex items-center">
        <div class="flex mr-10">
          <div class="px-6 flex flex-row items-center border-left-tp-nav h-10">
            <show-details-btn
              v-model="showCandidateInfo"
              title="candidate details"
              :main="true"
            />
          </div>
          <div class="px-6 flex flex-row items-center border-left-tp-nav">
            <svg
              width="20"
              height="16"
              viewBox="0 0 20 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.66667 0C8.118 0 9.35267 0.954023 9.81033 2.28562H18.8889C19.5026 2.28562 20 2.79729 20 3.42848C20 4.05966 19.5026 4.57134 18.8889 4.57134H9.81033C9.35278 5.90309 8.118 6.85714 6.66667 6.85714C5.21527 6.85714 3.98053 5.90309 3.52297 4.57134H1.11111C0.497467 4.57134 0 4.05966 0 3.42848C0 2.79729 0.497467 2.28562 1.11111 2.28562H3.52303C3.98066 0.954023 5.21534 0 6.66667 0ZM7.77778 3.42857C7.77778 2.79739 7.28031 2.28571 6.66667 2.28571C6.05301 2.28571 5.55556 2.79739 5.55556 3.42857C5.55556 4.05976 6.05301 4.57143 6.66667 4.57143C7.28031 4.57143 7.77778 4.05976 7.77778 3.42857Z"
                fill="#25213B"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.3333 9.14286C14.7847 9.14286 16.0193 10.0969 16.477 11.4285H18.8889C19.5026 11.4285 20 11.9401 20 12.5713C20 13.2025 19.5026 13.7142 18.8889 13.7142H16.477C16.0194 15.0459 14.7847 16 13.3333 16C11.8819 16 10.6472 15.0459 10.1897 13.7142H1.11113C0.497488 13.7142 2.11928e-05 13.2025 2.11928e-05 12.5713C2.11928e-05 11.9401 0.497488 11.4285 1.11113 11.4285H10.1897C10.6473 10.0969 11.882 9.14286 13.3333 9.14286ZM14.4444 12.5714C14.4444 11.9402 13.947 11.4286 13.3333 11.4286C12.7197 11.4286 12.2222 11.9402 12.2222 12.5714C12.2222 13.2026 12.7197 13.7143 13.3333 13.7143C13.947 13.7143 14.4444 13.2026 14.4444 12.5714Z"
                fill="#25213B"
              />
            </svg>
            <label
              for="my-modal-2"
              class="ml-3 font-normal modal-button underline text-base cursor-pointer"
            >
              Filters</label>
            <input
              id="my-modal-2"
              type="checkbox"
              class="modal-toggle"
            >
            <filter-modal
              v-model="filters"
              @applyFiltering="applySorting()"
            />
          </div>
        </div>
        <div class="pr-2">
          <select
            @change="e => { filters = { ...filters, requirementSpecificationId: e.target.value }; applySorting() }"
            :value="filters.requirementSpecificationId"
            class="form-select border px-8 py-4 select-campaign-dropdown text-base"
          >
            <option value="NO_REQ_SPEC">
              No requirement specification
            </option>
            <option disabled>
              ---
            </option>
            <option
              v-for="requirementSpecification in requirementSpecifications"
              :value="requirementSpecification.id"
              :key="requirementSpecification.id"
            >
              {{ requirementSpecification.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <hr class="h-2 mt-6 mb-10">
    <div class="flex flex-col">
      <table class="flex-auto table table-compact">
        <thead>
          <tr>
            <th class="scoreboard-table-hearer flex">
              <div class="flex items-center pb-1">
                <div class="w-12" />
                <div class="text-white normal-case text-base font-normal">
                  Name
                </div>
              </div>
            </th>
            <th class="scoreboard-table-hearer" />
            <th class="scoreboard-table-hearer">
              <div class="flex items-center space-x-4">
                <dropdown-table-header desc="Full circle means full test performed.">
                  <span class="text-white normal-case text-base font-normal">Test performed</span>
                </dropdown-table-header>
              </div>
            </th>
            <th class="scoreboard-table-hearer">
              <div class="flex space-x-4">
                <dropdown-table-header desc="The state indicated by the individual at the time of testing.">
                  <span class="text-white normal-case text-base font-normal">State </span>
                </dropdown-table-header>
                <div>
                  <sort-icon
                    v-model="sorting"
                    variable="state"
                  />
                </div>
              </div>
            </th>
            <th class="scoreboard-table-hearer">
              <div class="flex space-x-4">
                <dropdown-table-header desc="Strongest cognitive ability at the time of testing.">
                  <span class="text-white normal-case text-base font-normal">Strength </span>
                </dropdown-table-header>
                <div>
                  <sort-icon
                    v-model="sorting"
                    variable="strength"
                  />
                </div>
              </div>
            </th>
            <th class="scoreboard-table-hearer">
              <div class="flex space-x-4">
                <dropdown-table-header desc="Total average capacity score.">
                  <span class="text-white normal-case text-base font-normal">Total capacity </span>
                </dropdown-table-header>
                <div>
                  <sort-icon
                    v-model="sorting"
                    variable="total_capacity_score"
                  />
                </div>
              </div>
            </th>
            <th class="scoreboard-table-hearer">
              <div class="flex space-x-4">
                <dropdown-table-header desc="Tendency in estimation of own capacity. See details in the full report.">
                  <span class="text-white normal-case text-base font-normal">Self-Awareness </span>
                </dropdown-table-header>
                <div>
                  <sort-icon
                    v-model="sorting"
                    variable="awareness"
                  />
                </div>
              </div>
            </th>
            <th class="scoreboard-table-hearer">
              <div class="flex space-x-4 ">
                <dropdown-table-header desc="Tendency in performance under pressure.">
                  <span class="text-white normal-case text-base font-normal">Handling pressure </span>
                </dropdown-table-header>
                <div>
                  <sort-icon
                    v-model="sorting"
                    variable="variation"
                  />
                </div>
              </div>
            </th>
            <th
              class="scoreboard-table-hearer"
              v-if="filters.requirementSpecificationId !== 'NO_REQ_SPEC'"
            >
              <div class="flex space-x-4 ">
                <dropdown-table-header desc="How well the candidate match your requirements">
                  <span class="text-white normal-case text-base font-normal"> Match </span>
                </dropdown-table-header>
                <div>
                  <sort-icon
                    v-model="sorting"
                    variable="matching"
                  />
                </div>
              </div>
            </th>
            <th class="scoreboard-table-hearer">
              <div class="flex space-x-4 justify-center">
                <span class="text-white normal-case text-base font-normal">Reports </span>
              </div>
            </th>
            <th class="scoreboard-table-hearer">
              <div class="flex space-x-4 justify-center">
                <span class="text-white normal-case text-base font-normal">Share </span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="showLoading || empty">
            <td />
            <td />
            <td />
            <td>
              <div class="flex items-center justify-center w-full h-full">
                <button
                  v-if="showLoading"
                  class="btn btn-lg btn-circle btn-ghost loading"
                />
                <span
                  v-if="!showLoading && empty"
                  class="text-base"
                >
                  No candidates
                </span>
              </div>
            </td>
          </tr>
          <template v-else>
            <table-row
              v-for="candidate in candidates"
              :key="candidate.id"
              :candidate="candidate"
              :show-info="showInfo"
              :show-candidate-info="showCandidateInfo"
              :sorting="sorting"
              :campaign-id="campaignId"
              @openReport="reportModalData = $event"
              @share="shareModalData = $event"
            />
          </template>
        </tbody>
      </table>

      <div
        v-if="currentPages[1] > 1"
        class="flex justify-center my-12 btn-group"
      >
        <button
          v-for="page in currentPages[1]"
          :key="page"
          class="btn btn-outline btn-base"
          :class="{ 'btn-active': page === currentPages[0] + 1 }"
          @click="nextPage(page - 1)"
        >
          {{ page }}
        </button>
      </div>
    </div>
    <confirm-report-modal
      :report-type="reportModalData.reportType"
      @close="reportModalData = null"
      v-if="reportModalData"
      :candidate="reportModalData.candidate"
      :campaign-id="campaignId"
      :label="reportModalData.label"
      :show-info="showInfo"
    />
    <share-modal
      v-if="shareModalData"
      :open="!!shareModalData"
      :candidate="shareModalData.candidate"
      @close="shareModalData = null"
      :campaign-id="this.campaignId"
    />
  </div>
</template>

<script>
import TableRow from '../components/TableRow.vue'
import DropdownTableHeader from '../components/DropdownTableHeader.vue'
import SortIcon from '../components/SortIcon.vue'
import ShowDetailsBtn from '../components/ShowDetailsBtn.vue'
import FilterModal from '../components/FilterModal.vue'
import { mapGetters } from 'vuex'
import ConfirmReportModal from '../components/ConfirmReportModal.vue'
import ShareModal from '@/modules/AppReport/components/ShareModal.vue'

export default {
  components: {
    TableRow,
    DropdownTableHeader,
    SortIcon,
    ShowDetailsBtn,
    FilterModal,
    ConfirmReportModal,
    ShareModal
  },
  props: {
    campaignId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      gettingCandidates: false,
      showCandidateInfo: false,
      showConfirmReportModal: false,
      showInfo: true,
      reportModalData: null,
      shareModalData: null
    }
  },
  computed: {
    ...mapGetters({
      candidates: 'SCOREBOARD/getCandidates',
      issues: 'SCOREBOARD/getCandidatesTestIssues',
      currentPages: 'SCOREBOARD/getPages',
      requirementSpecifications: 'REQUIREMENT_SPECIFICATIONS/getRequirementSpecifications'
    }),
    filters: {
      get () {
        return this.$store.state.SCOREBOARD.filters
      },
      set (value) {
        this.$store.dispatch('SCOREBOARD/updateFilters', value)
      }
    },
    sorting: {
      get () {
        return this.$store.state.SCOREBOARD.sorting
      },
      set (value) {
        this.$store.dispatch('SCOREBOARD/updateSorting', value)
      }
    },
    showLoading () {
      return this.gettingCandidates
    },
    empty () {
      return this.candidates.length === 0
    }
  },

  watch: {
    sorting: {
      async handler (newSort, oldSort) {
        await this.applySorting()
      },
      deep: true
    }
  },

  async mounted () {
    await this.$store.dispatch('USER/updateSubscriptionStatus')
    await this.$store.dispatch('REQUIREMENT_SPECIFICATIONS/getRequirementSpecifications')

    const id = this.campaignId
    this.gettingCandidates = true
    await this.$store.dispatch('SCOREBOARD/getCandidates', id)
    await this.$store.dispatch('SCOREBOARD/getCandidatesTestIssues', id)
    this.gettingCandidates = false
    this.mapIssuesAndUsers()

    if (this.candidates && Array.isArray(this.candidates)) {
      for (const candidate of this.candidates) {
        if (candidate.stages && Symbol.iterator in Object(candidate.stages)) {
          for (const stage of candidate.stages) {
            if (stage !== 'full_cognitive_report') {
              this.showInfo = false
            }
          }
        }
      }
    }
  },

  methods: {
    async applySorting () {
      this.gettingCandidates = true
      this.$store.commit('SCOREBOARD/SET_CURRENT_PAGE', 0)
      await this.$store.dispatch('SCOREBOARD/getCandidates', this.campaignId)
      await this.$store.dispatch('SCOREBOARD/getCandidatesTestIssues', this.campaignId)
      this.gettingCandidates = false
      this.mapIssuesAndUsers()
    },
    async nextPage (page) {
      this.$store.commit('SCOREBOARD/SET_CURRENT_PAGE', page)
      await this.$store.dispatch('SCOREBOARD/getCandidates', this.campaignId)
      await this.$store.dispatch('SCOREBOARD/getCandidatesTestIssues', this.campaignId)
      this.mapIssuesAndUsers()
    },
    mapIssuesAndUsers () {
      for (let index = 0; index < this.candidates.length; index++) {
        const filterIssue = this.issues.filter(x => x.user_id === this.candidates[index].user_id)
        if (filterIssue.length > 0) {
          this.candidates[index].testIssue = filterIssue
        } else {
          this.candidates[index].testIssue = null
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '../scoreboard.scss';
</style>
